import { render, staticRenderFns } from "./imHistory.vue?vue&type=template&id=09f43a2f&scoped=true"
import script from "./imHistory.vue?vue&type=script&lang=js"
export * from "./imHistory.vue?vue&type=script&lang=js"
import style0 from "./imHistory.vue?vue&type=style&index=0&id=09f43a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f43a2f",
  null
  
)

export default component.exports